import { useMemo } from 'react'
import { useAudioNoteMeeting, useDetectedAudioNoteMeeting } from './audio/use-audio-note-selectors'
import { isScheduledMeeting } from '@shared/utils/audio-notes/AudioNoteUtils'

/**
 * Hook to access current meeting state.
 *
 * Reads only the meeting/detectedMeeting slices of audio-note-state (with
 * value equality), so status/summary ticks during a recording don't re-render
 * consumers — only an actual meeting change does.
 */
export const useCurrentMeeting = () => {
  const meeting = useAudioNoteMeeting()
  const detectedMeeting = useDetectedAudioNoteMeeting()

  return useMemo(() => {
    if (!meeting) {
      return {
        currentDetectedMeeting: null,
        currentScheduledMeeting: null,
        activeMeeting: null,
        detectedMeeting,
      }
    }

    const isScheduled = isScheduledMeeting(meeting)
    return {
      currentDetectedMeeting: !isScheduled ? meeting : null,
      currentScheduledMeeting: isScheduled ? meeting : null,
      activeMeeting: {
        meeting,
        isScheduled,
      },
      detectedMeeting,
    }
  }, [meeting, detectedMeeting])
}
